import {
  Component,
  Prop,
  Event,
  State,
  h,
  type EventEmitter,
} from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../../conversational-search-partials/label-with-section/label-with-section';
import { getRandomUniqueItemsFromArray } from '../../../conversational-search-logic/utils/utils';
import { predefinedQuestionsSuggestions } from '../predefined-suggestions/predefined-suggestions';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import EventEmitterComponent from '../../../conversational-search-partials/event-emitter-component/event-emitter-component';
@Component({
  tag: 'uiaas-search-conversational-search-message-terms-and-conditions-external-origin',
  styleUrl: 'terms-and-conditions-external-origin.scss',
  shadow: true,
})
export class ConversationalSearchTermsAndConditionsExternalOrigin {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly query: string;
  @Prop() readonly conversationalSearchBrandUrl?: string;
  @Prop() readonly country: string;
  @Prop() readonly language: string;

  @State() isTermsAndConditionsModalVisible = false;
  @State() uniqueRandomItems: string[];

  @Event({
    eventName: 'conversational-search:terms-and-conditions-modal',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    termsAndConditionsModalEventEmitter: EventEmitter<{
    isModalVisible: boolean;
  }>;

  private handleUniqueSuggestions() {
      const predefinedSuggestionsWithLabels = predefinedQuestionsSuggestions(this.labelProvider);
      this.uniqueRandomItems = getRandomUniqueItemsFromArray(predefinedSuggestionsWithLabels, 4);
  }

  connectedCallback() {
      this.handleUniqueSuggestions();
  }

  render() {
      const smilingFaceIcon = String.fromCodePoint(128578);
      const text = this.labelProvider(
        'conversational.search.terms.and.conditions.message.external.origin',
        'To continue the conversation and ask me any question I need you to accepting the {1}.',
      );

      return (
        <div class="conversational-search-messages-terms-and-conditions-external-origin">
          <section class="conversational-search-messages-terms-and-conditions-external-origin-header">
            {this.labelProvider(
              'conversational.search.greeting.header',
              'Hello, I\'m GenAI Search, your friendly search assistant',
            )}
            <span class="conversational-search-messages-terms-and-conditions-external-origin-header__icon">
              {smilingFaceIcon}
            </span>
          </section>
          <uiaas-search-widget-conversational-search-suggestion-tiles
            items={this.uniqueRandomItems}
            query={this.query}
            disabled={true}
            carouselItemWidth={170}
          />
          <ConversationalSearchLabelWithSection text={text}>
            <EventEmitterComponent isNotPropagatedForEnter={true} eventName='conversational-search:terms-and-conditions-modal' isModalVisible={true}>
              <EventEmitterComponent isNotPropagatedForEnter={true} eventName='conversational-search:ga-cta' ctaName={'Terms and Conditions'} keyword={this.query}>
                <qds-inline-link>
                  {this.labelProvider(
                    'conversational.search.terms.and.conditions.external',
                    'Terms and Conditions',
                  )}
                </qds-inline-link>
              </EventEmitterComponent>
            </EventEmitterComponent>
          </ConversationalSearchLabelWithSection>
          <uiaas-search-conversational-search-acceptance-cta
            query={this.query}
            labelProvider={(e, f) => this.labelProvider(e, f)}
            language={this.language}
            country={this.country}
            conversationalSearchBrandUrl={
              this.conversationalSearchBrandUrl
            }
          />
        </div>
      );
  }
}
